export const downloadCSVWithBOM = (csv: string, filename: string) => {
    const csvString =
        "text/csv;charset=utf-8,%EF%BB%BF" + encodeURIComponent(csv)
    const a = document.createElement("a")
    a.href = "data:" + csvString
    a.download = filename
    a.click()
    a.remove()
}
